import { Button } from '#app/components/ui/button.tsx'

export default function Page() {
	return (
		<main className="container">
			<section className="ml-2 mt-4">
				<h1 className="py-2  text-2xl font-light leading-[100%] text-[#232323]">
					月次面談シート シートタイプイメージ
				</h1>
			</section>
			<section className="overflow-x-auto">
				<div className="flex">
					<img
						src="/img/monthly-meeting-sheet-type.jpg"
						alt="monthly-meeting-sheet-type"
					/>
				</div>
			</section>
			<section className="mt-8">
				<div className="flex justify-center">
					<Button
						variant={'outline'}
						className="bg-white font-semibold"
						onClick={() => {
							window.close()
						}}
					>
						閉じる
					</Button>
				</div>
			</section>
		</main>
	)
}
